import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";

const ColorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  padding: 16px;
`;

const ColorCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 12px;
`;

const ColorSwatch = styled.div`
  width: 100%;
  height: 60px;
  border-radius: 4px;
  background-color: ${(props) => props.color};
`;

const ColorInfo = styled.div`
  margin-top: 8px;
  font-family: monospace;
  font-size: 14px;
`;

const renderColorSet = (colors, path = []) => {
  if (typeof colors !== "object" || colors === null) {
    return null;
  }

  return Object.entries(colors).map(([key, value]) => {
    const currentPath = [...path, key];

    if (typeof value === "string" && value.match(/^#|rgb|hsl/)) {
      return (
        <ColorCard key={currentPath.join(".")}>
          <ColorSwatch color={value} />
          <ColorInfo>
            <div>{currentPath.join(".")}</div>
            <div>{value}</div>
          </ColorInfo>
        </ColorCard>
      );
    }

    if (typeof value === "object") {
      return renderColorSet(value, currentPath);
    }

    return null;
  });
};

export const PaletteDebug = () => {
  const theme = useTheme();

  return (
    <ColorGrid>
      {renderColorSet(theme.palette || theme.colors || theme)}
    </ColorGrid>
  );
};
